module.exports = __webpack_public_path__ + "img/1499631089.1956299d.jpg";